import { mapActions, mapState } from "vuex";

export default {
    props: {
        accessory: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            originlQty: 1,
            qty: 1,
            selectedVariant: null
        }
    },
    computed: {
        ...mapState({
            cart: state => state.StarterPc.cart,
            isUpdating: state => state.StarterPc.isUpdating,
            rules: state => state.StarterPc.rules
        }),
        productImage() {
            const marketingImage = this.variantInCart &&
                this.variantInCart.images_marketing &&
                this.variantInCart.images_marketing[0].image_url;

            const variantImage = this.selectedVariant &&
                this.selectedVariant.images_marketing &&
                this.selectedVariant.images_marketing[0].image_url;

            const defaultImage = this.accessory.images_cover &&
                this.accessory.images_cover[0].image_url;

            return marketingImage || variantImage || defaultImage;
        },
        productInCart() {
            if (this.type == "streamingBundle") {
                return this.cart.streamingBundle.id ? this.cart.streamingBundle : null;
            }

            return this.cart[this.type].find(item => item.products_id == this.accessory.id);
        },
        productInRules() {
            return this.rules.find(item => item.products_id == this.accessory.id);
        },
        variantInCart() {
            const variantId = this.productInCart && this.productInCart.id;

            return this.accessory.variants.find(item => item.id == variantId);
        }
    },
    watch: {
        productInRules(rule) {
            if (rule && rule.ruleType == "prevent") {
                this.qty = this.originlQty;
                this.originlQty = 1;
            }
        }
    },
    created() {
        this.qty = this.productInCart && this.productInCart.quantity || 1;
    },
    methods: {
        ...mapActions({
            removePart: "StarterPc/removePart",
            updatePart: "StarterPc/updatePart"
        }),
        selectVariant(variant) {
            this.selectedVariant = variant;
        },
        updateAccessories(qty) {
            this.originlQty = this.productInCart && this.productInCart.quantity || 1;

            this.updatePart({ part: this.variantInCart || this.selectedVariant || this.accessory.variants[0], qty });
        }
    }
}
